import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { IconsModule } from '../icons/icons.module';
import { ModalComponent } from './modal.component';
import { ClickOutsideDirectiveModule } from '../../directives/click-outside/click-outside-directive.module';
import { ButtonModule } from '../buttons/button.module';
import { TrapFocusModule } from '../../directives/trap-focus/trap-focus.module';

@NgModule({
  declarations: [ModalComponent],
  imports: [CommonModule, UiTranslateModule, IconsModule, ClickOutsideDirectiveModule, TrapFocusModule, ButtonModule],
  exports: [ModalComponent],
  providers: [],
})
export class ModalModule {}
